import { MarketsQuery } from '@graphql/Markets/markets.graphql.gen';
import React, { PropsWithChildren } from 'react';

export type IMarket = Partial<MarketsQuery['markets'][number]>;

interface IMarketsContext {
  markets: IMarket[];
}

// Fallback markets if the API call fails
export const fallbackMarkets = [
          {
            name: 'Austin',
            slug: 'austin',
            coordinates: [287.682, 323.626]
          },
          {
            name: 'Boston',
            slug: 'boston'
          },
          {
            name: 'Chicago',
            slug: 'chicago',
            coordinates: [406.943, 138.796]
          },
          {
            name: 'Dallas',
            slug: 'dallas',
            coordinates: [303.554, 294.434]
          },
          {
            name: 'Denver',
            slug: 'denver',
            coordinates: [177.27, 161.551]
          },
          {
            name: 'Houston',
            slug: 'houston',
            coordinates: [314.334, 332.116]
          },
          {
            name: 'Los Angeles',
            slug: 'los-angeles',
            coordinates: [48.169, 227.796]
          },
          {
            name: 'New York',
            slug: 'new-york',
            coordinates: [568.169, 138.796]
          },
          {
            name: 'Seattle',
            slug: 'seattle',
            coordinates: [58.169, 14.796]
          },
          {
            name: 'Washington DC',
            slug: 'washington-dc',
            coordinates: [555.169, 161.296]
          }
        ];

export const MarketsContext = React.createContext<IMarketsContext>({
  markets: fallbackMarkets
});

interface IMarketsProviderProps {
  markets: Array<IMarket>;
}

export function MarketsProvider({
 children, markets
}: PropsWithChildren<IMarketsProviderProps>) {
  return (
    <MarketsContext.Provider value={{ markets }}>
      {children}
    </MarketsContext.Provider>
  );
}

export default MarketsContext;
